import { Theme, useMediaQuery } from '@material-ui/core';

interface ReturnUseDeviceScreen {
  IS_MOBILE: boolean;
  IS_TABLET: boolean;
}

export default function useDeviceScreen(): ReturnUseDeviceScreen {
  const IS_MOBILE = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('xs')
  );
  const IS_TABLET = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );

  return { IS_MOBILE, IS_TABLET };
}
